import { useEffect } from "react"
import { connect } from "react-redux"
import { API_BASE_URL } from "./../constants/API"
import { logout, restoreAuthFromLocalStorage } from "./../modules/common/store/actions"

const AuthChecker = ({ token, currentUser, isAuthenticated, logout, restoreAuthFromLocalStorage, _persist }) => {
  useEffect(() => {
    // Attendre que redux-persist soit complètement hydraté
    if (!_persist || !_persist.rehydrated) {
      console.log('AuthChecker: En attente de la rehydratation Redux...', _persist)
      return
    }

    const validateToken = async () => {
      console.log('AuthChecker: Début de la validation', { 
        hasToken: !!token, 
        hasCurrentUser: !!currentUser, 
        isAuthenticated,
        tokenAccess: token?.access ? token.access.substring(0, 50) + '...' : 'N/A',
        persistRehydrated: _persist?.rehydrated
      })
      
      let tokenToValidate = token?.access
      
      // Si on n'a pas de token dans Redux, essayer de le récupérer depuis localStorage
      if (!tokenToValidate) {
        tokenToValidate = localStorage.getItem('auth_token')
        if (tokenToValidate) {
          console.log('AuthChecker: Token trouvé dans localStorage', tokenToValidate.substring(0, 50) + '...')
        }
      }
      
      // Si on a un token (Redux ou localStorage)
      if (tokenToValidate) {
        try {
          console.log('AuthChecker: Envoi de la requête de validation...')
          
          // Vérifier si le token est toujours valide côté serveur
          const response = await fetch(`${API_BASE_URL}/auth/token-verify`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ token: tokenToValidate })
          })

          console.log('AuthChecker: Réponse reçue', { status: response.status, ok: response.ok })

          if (!response.ok) {
            // Token invalide ou expiré, déconnecter l'utilisateur
            console.log('AuthChecker: Token invalide, déconnexion automatique')
            logout()
          } else {
            console.log('AuthChecker: Token valide')
            
            // Si on avait un token dans localStorage mais pas dans Redux,
            // cela signifie que redux-persist a échoué - restaurer l'état
            if (tokenToValidate && !token?.access) {
              console.log('AuthChecker: Redux-persist a échoué, restauration de l\'état depuis localStorage')
              restoreAuthFromLocalStorage()
            }
          }
        } catch (error) {
          console.error('AuthChecker: Erreur de validation:', error)
          // En cas d'erreur réseau, on pourrait déconnecter par sécurité
          // mais pour l'instant on laisse connecté pour éviter les déconnexions intempestives
          console.log('AuthChecker: Erreur réseau, utilisateur reste connecté')
        }
      } else {
        console.log('AuthChecker: Pas de token trouvé (ni Redux ni localStorage)')
      }
    }

    // Délai supplémentaire pour s'assurer que l'état Redux est complètement hydraté
    const timeoutId = setTimeout(validateToken, 100)

    return () => clearTimeout(timeoutId)
  }, [token, currentUser, isAuthenticated, logout, restoreAuthFromLocalStorage, _persist])

  // Ce composant ne rend rien, il fait juste la validation en arrière-plan
  return null
}

const mapStateToProps = (state) => ({
  token: state.common.auth.token,
  currentUser: state.common.auth.currentUser,
  isAuthenticated: state.common.auth.isAuthenticated,
  _persist: state._persist
})

const mapDispatchToProps = {
  logout,
  restoreAuthFromLocalStorage
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthChecker)
